<template>
<div class="stockchart-root" :class="{ 'has-search-title': is_a_search, 'is-table': !_g_ToggleBetweenTableAndChart }">
<div v-if="!isMobile">
    <Finder />
    <div v-if="_g_UserFeatures.has_active_role">
        <div v-show="_g_ToggleBetweenTableAndChart">
            <div v-if="is_a_search" class="title-searches">
              <span class="search-text">Búsqueda: {{search_text}}</span>
              <!-- Save current tickers as favorite workspace (visible only for logged users) -->
              <button v-if="_g_IsUserLogged && stocks && stocks.length > 0" class="save-fav-btn" @click="_showCreateFavoritesModal" :title="'Crear carpeta de favoritos con ' + stocks.length + ' tickers'">
                <span class="material-icons-outlined">grade</span>
                <span class="save-fav-text">Crear carpeta de favoritos con estos tickers</span>
              </button>
              <span class="material-icons-outlined close-searches" @click="_closeSearch()">close</span>
            </div>
            <div class="main-sidebar-left">
                <div class="stocks-container">
                    <Stocks :managed="true" :key="$route.params.param1 + '-' + ($route.params.param2 || '')" />
                </div>            
            </div>
            <!-- <img v-if="this._g_User.is_asistente_dif" src="/sites/all/themes/Porto_sub/img/banner-big.png" class="banner-big-bank"> -->
            <div class="mdc-layout-grid__inner sidebar-menu-margin" id="dragable-container">
                <div v-if="_g_SelectedTicker && _g_SelectedTicker.chart" class="mdc-layout-grid__cell--span-12 stockchart-chart">                   
                    <div v-if="isIframeLoading" class="iframe-loading-indicator">
                      <div class="wave"></div>
                      <div class="wave"></div>
                      <div class="wave"></div>
                    </div>
                    <iframe :src="url_stock" width="100%" frameborder="0" id="iframe" style="height: 100%;" title="Gráfico del valor seleccionado"
                      :class="{'chart-with-search-tittle': is_a_search, 'iframe-loading': isIframeLoading, 'iframe-loaded': !isIframeLoading}"
                      @load="handleIframeLoad"></iframe>
                </div>
                <div v-else class="legacy-chart-empty" role="status">No hay un valor seleccionado. Ajusta los filtros para encontrar valores.</div>
            </div>
        </div>

        <div v-show="!_g_ToggleBetweenTableAndChart">
            <div v-if="is_a_search" class="title-searches">
              <span class="search-text">Búsqueda: {{search_text}}</span>
              <!-- Save current tickers as favorite workspace (visible only for logged users) -->
              <button v-if="_g_IsUserLogged && stocks && stocks.length > 0" class="save-fav-btn" @click="_showCreateFavoritesModal" :title="'Crear carpeta de favoritos con ' + stocks.length + ' tickers'">
                <span class="material-icons-outlined">grade</span>
                <span class="save-fav-text">Crear carpeta de favoritos con estos tickers</span>
              </button>
              <span class="material-icons-outlined close-searches" @click="_closeSearch()">close</span>
            </div>
            <div class="main-sidebar-left">
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin-stocks-table" id="legacy-table-container">
                <div class="mdc-layout-grid__cell--span-12">
                    <StocksTable :managed="true" :active="!_g_ToggleBetweenTableAndChart" />
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <div v-if="_g_ToggleBetweenTableAndChart">
            <div v-if="is_a_search" class="title-searches">
              <span class="search-text">Búsqueda: {{search_text}}</span>
              <!-- Save current tickers as favorite workspace (visible only for logged users) -->
              <button v-if="_g_IsUserLogged && stocks && stocks.length > 0" class="save-fav-btn" @click="_showCreateFavoritesModal" :title="'Crear carpeta de favoritos con ' + stocks.length + ' tickers'">
                <span class="material-icons-outlined">grade</span>
                <span class="save-fav-text">Crear carpeta de favoritos con estos tickers</span>
              </button>
              <span class="material-icons-outlined close-searches" @click="_closeSearch()">close</span>
            </div>
            <div class="main-sidebar-left">
                <div class="stocks-container">
                    <Stocks :key="$route.params.param1 + '-' + ($route.params.param2 || '')" />
                </div>            
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin" id="dragable-container">
                <div class="mdc-layout-grid__cell--span-12 stockchart-chart">
                    <div @keyup.enter="_searchStocks()" class="vanilla-input-container">
                        <input 
                          type="text" 
                          id="searcher-tickers" 
                          v-model="ticker_url" 
                          placeholder="Enter ticker..." 
                          class="vanilla-ticker-input"
                        />
                    </div>
                    <iframe :src="url_anonymous" width="98.55%" frameborder="0" id="iframe" style="height: 98%;"
                      @load="handleIframeLoad"></iframe>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="main-sidebar-left">
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin-stocks-table" id="legacy-table-container">
                <div class="mdc-layout-grid__cell--span-12">
                    <StocksTable />
                </div>
            </div>
        </div>
    </div>
</div>

<div v-else style="height: 100%;">
  <div v-if="_g_UserFeatures.has_active_role" style="height: 100%;">
    <div v-if="!_g_option_mobile" style="height: 100%;">
      <div v-if="isIframeLoading && url_stock" class="iframe-loading-indicator">
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
      <iframe v-if="url_stock" :src="url_stock" width="100%" frameborder="0" id="mobile-iframe" style="height: 100%;"
        :class="{'iframe-loading': isIframeLoading, 'iframe-loaded': !isIframeLoading}"
        @load="handleIframeLoad"></iframe>
    </div>
  </div>
  <div v-else style="height: 100%;">
    <div class="mdc-layout-grid__cell--span-12 anonymous-stockchart-chart" style="height: 100%; overflow-y: scroll;">
        <div @keyup.enter="_searchStocks()">
          <InputTextOutline id="searcher-tickers" style="width: 15%; margin-left: 6px; margin-top: 5px;" @_emit_method_order_input="_getValueFromInput" ref="getInputMontanteInferior" :permission="true" :character_counter_permission="false" :icon_permission="true" :helper_permission="true" input_key_to_save_user_values="ticker" input_class_character_counter="ticker-counter" icon_class="input-icon" icon_name="" input_label="" input_helper="" :has_focus="false" :length="32" computed_value="MSFT" :computed_value_permission="true" :test_field_is_numeric="false" />
        </div>
        <iframe :src="url_anonymous" width="100%" frameborder="0" id="mobile-iframe" style="height: 100%;"
          @load="handleIframeLoad"></iframe>
      </div>
  </div>
</div>

<!-- Custom Create Favorites Modal -->
<div v-if="showCreateFavoritesModal" class="modal-overlay" @click="showCreateFavoritesModal = false">
  <div class="favorites-modal-content" @click.stop>
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="title-wrapper">
        <span class="material-icons-outlined header-icon">grade</span>
        <h3 class="modal-title">Crear Carpeta de Favoritos</h3>
      </div>
      <button class="modal-close-btn" @click="showCreateFavoritesModal = false">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <p class="modal-description">
        Se creará una nueva carpeta de favoritos con <strong>{{stocks ? stocks.length : 0}} tickers</strong> de la búsqueda actual.
      </p>
      
      <div class="create-input-wrapper">
        <button class="icon-button color-trigger-btn" @click="_toggleColorGrid($event)">
          <span class="material-icons-outlined item-icon" :style="{ color: selectedColor }">star</span>
        </button>
        <input
          type="text" 
          class="vanilla-input create-fav-input" 
          v-model="folderName" 
          placeholder="Nombre de la carpeta" 
          :maxlength="32"
          ref="createFavInput"
          @keyup.enter="_createFavoritesFolder()"
          @keyup.esc="showCreateFavoritesModal = false"
        />
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="action-btn secondary-btn" @click="showCreateFavoritesModal = false">Cancelar</button>
      <button class="action-btn primary-btn" @click="_createFavoritesFolder()" :disabled="!folderName.trim()">Crear Carpeta</button>
    </div>

    <!-- Custom Color Grid Popup -->
    <div v-if="showColorGrid" class="color-grid-popup" :style="colorGridStyle" ref="colorGridPopup">
      <div v-for="(color, index) in gridColors" 
           :key="index" 
           class="color-grid-item" 
           :style="{ backgroundColor: color }"
           @click="_selectColor(color)">
      </div>
    </div>
  </div>
</div>
</div>
</template>


<script>
import Stocks from '@/features/stockchart/components/Stocks.vue'
import Finder from '@/features/stockchart/components/Finder/Finder-Base.vue'
import StocksTable from '@/features/stockchart/components/StocksTable.vue'
import InputTextOutline from "@/shared/components/ui/InputTextOutline.vue";
import { mapMutations, mapGetters } from "vuex";
import APICaller from "@/shared/mixins/APICaller.js";
import GetStocks from "@/shared/mixins/GetStocks.js";

//import Chart from '@/features/stockchart/components/TVChartContainer.vue' para importar el tradingview descomentamos esta linea

import { isMobile } from 'mobile-device-detect';
import { isTablet } from 'mobile-device-detect';

export default {
  mixins: [APICaller, GetStocks],
  name: 'Stockchart',
  props: { portfolioReady: { type: Boolean, default: true } },
  components: {
    Finder,
    Stocks,
    StocksTable,
    InputTextOutline,
    //Chart, descomentamos tambien esta linea
  },
  data: () => ({
      isMobile: window.innerWidth < 901,
      symbol: "",
      url_anonymous: "https://www.stonicks.com/embed/?c=4E6E82&sc=logaritmic&s=MSFT",
      ticker_url: "",
      url_stock: "",
      stocks: [],
      selected_ticker: {},
      search_text: "",
      is_a_search: false,
      modeOfStocks: '',
      myWidth: 0,
      isIframeLoading: true,
      lastUrlStock: "",
      lastUrlAnonymous: "",
      areStocksLoaded: false,
      previousToggleState: null,
      showCreateFavoritesModal: false,
      folderName: '',
      selectedColor: '#ff0000',
      showColorGrid: false,
      colorGridStyle: {},
      gridColors: [
        '#ff0000', '#ff6000', '#ffbf00', '#dfff00', '#80ff00', '#20ff00', '#00ff40', '#00ff9f',
        '#00ffff', '#009fff', '#0040ff', '#2000ff', '#8000ff', '#df00ff', '#ff00bf', '#ff0060'
      ],
  }),
  mounted() {
    this.myWidth = window.width;
    this._searchTitle()
    this._initializeCollection();
    this.tickerChangerWatcher();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })

    // Initialize the previous toggle state
    this.previousToggleState = this._g_ToggleBetweenTableAndChart;

    // Add event listeners for color grid
    document.addEventListener('click', this._handleClickOutside, true);
    window.addEventListener('resize', this._handleResize);
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('click', this._handleClickOutside, true);
    window.removeEventListener('resize', this._handleResize);
    window.removeEventListener('resize', this.onResize);
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  watch:{
    _g_IsUserLogged(logged) { if (logged) this._initializeCollection(); },
    portfolioReady(ready) { if (ready) this._initializeCollection(); },
    // Add route watcher to handle navigation changes
    '$route': {
      handler: function(to, from) {
        // Only reload stocks if the route params actually changed
        if (to.params.param1 !== from.params.param1 || to.params.param2 !== from.params.param2) {
          this._searchTitle(); // Update search title
          // Reload stocks with the new parameters
          if (this._g_IsUserLogged) {
            this.getStocks(() => {
              this.areStocksLoaded = true;
              this._checkAllLoaded();
            });
          }
        }
      },
      immediate: false
    },
    
    filters: {
      hadler: function(){
        process.env.VUE_APP_API + '/stockchart?t=23&s=' + this._g_SelectedTicker.ticker;
      },
    deep: true
    },

    _g_SelectedTicker: {
      handler: function(){
        this._url_stock();
      }
    },

    _g_stocks: {
      handler: function(newVal, oldVal){
        this.stocks = newVal;
      },
    },
    
    url_stock: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal && newVal !== this.lastUrlStock) {
          this.isIframeLoading = true;
          this.lastUrlStock = newVal;
        }
      }
    },
    
    url_anonymous: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal && newVal !== this.lastUrlAnonymous) {
          this.isIframeLoading = true;
          this.lastUrlAnonymous = newVal;
        }
      }
    },
    
    _g_ToggleBetweenTableAndChart: {
      handler: function(newVal, oldVal) {
        if (newVal) this.$nextTick(() => {
          const iframe = this.$el.querySelector('iframe');
          try { if (iframe && iframe.contentWindow) iframe.contentWindow.dispatchEvent(new iframe.contentWindow.Event('resize')); } catch (_) { /* External anonymous embed. */ }
        });
      }
    }
  },
  /////////////////////////////////////////////////////////////////////////////////////////////
  computed: {
    ...mapGetters(['_g_ToggleBetweenTableAndChart']),
    ...mapGetters({_g_stocks:'_g_Stocks'}),
    ...mapGetters(['_g_SelectedTicker', "_g_IsUserLogged", "_g_option_mobile", "_g_User", "_g_UserFeatures"]),
  },
  methods: {
    _initializeCollection() {
      if (!this.portfolioReady || !this._g_IsUserLogged || this._initializingCollection) return;
      this._initializingCollection = true;
      this._changeModeToStockMarket();
    },
    ...mapMutations(["setSelectedTicker", "setStocks", "setWorkspaceCreated"]),
    
    handleIframeLoad(event) {
      // Use the event's target (the iframe that actually loaded) instead of hard-coded IDs
      const iframe = event && (event.target || event.currentTarget);

      if (iframe && iframe.src && iframe.src.trim() !== '') {
        this.isIframeLoading = false;
        this._checkAllLoaded();
      }
    },
    
    _checkAllLoaded() {
      // Only emit the stocks-loaded event when both stocks and iframe are loaded
      if (this.areStocksLoaded && !this.isIframeLoading) {
        this.$emit('stocks-loaded');
      }
    },
    
    onResize() {
      this.isMobile = window.innerWidth < 901
      if(window.innerWidth < 901 && this.myWidth != window.width){
        window.location.reload()
      }
    },
    _getValueFromInput(value){
        this.ticker_url = value[0]
    },
    _searchStocks: function(){
      this.url_anonymous = "https://www.stonicks.com/embed/?c=4E6E82&sc=logaritmic&s=" + this.ticker_url
    },

    _closeSearch: function(){
      window.sessionStorage.removeItem('ticker_search_by_user');
      this.$router.push('/app/graficador-dinamico');
    },
    _searchTitle: function(){
      if(this.$route.params.param1 == undefined){
        this.is_a_search =  false;
      }else{
        this.is_a_search = true;
        let param_1 = this.$route.params.param1;
        let param_2 = this.$route.params.param2;
        const dictSubSearch = {
          'last_week': "última semana",
          'last_month': "último mes",
          'last_three_months': "últimos 3 meses",
          'last_year': "último año",
          'Energy': "Energía",
          'Materials': "Materiales",
          'Utilities': "Servicios públicos",
          'Financials': "Finanzas",
          'Consumer Staples': "Productos de 1ª necesidad",
          'Real Estate': "Inmobiliario",
          'Communication Services': "Comunicación",
          'Industrials': "Industrial",
          'Consumer Discretionary': "Consumo discrecional",
          'Health Care': "Salud",
          'Information Technology': "Tecnologías de la información",
        };
        const dictSearches = {
          "last-ipos": "Últimas IPOs",
          "best-bullish-values": "Valores alcistas " + dictSubSearch[param_2],
          "hot-values": "Más comentados " + dictSubSearch[param_2],
          "exchange": "Índice " + param_2,
          "sector":"Sector " + dictSubSearch[param_2],
          "platinum": "Valores Platino",
          "favorites": param_2,
          "twin-souls": "Almas gemelas",
          "ticker": "Ticker " + param_2,
          "waitings": "Valores en espera",
          "open-positions": "Posiciones abiertas",
          "all-values": "Valores en la cartera",
          "best-sectors": "Mejores sectores " + dictSubSearch[param_2],
          "informe": "Informe " + this.formatInformeSlugForDisplay(param_2),
        };
        this.search_text = dictSearches[param_1] || param_1;
      }
    },

    _changeModeToStockMarket: function(){
      let success = (response) => {
        if (this._isDestroyed) return;
        this.modeOfStocks = response;
        this.getStocks(() => { this.areStocksLoaded = true; this._checkAllLoaded(); });
      };
      let url = "/api/v1/stock-finder/change-search-mode/stock-market";

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('231', 'Error cambiando modo de búsqueda.', () => { this._initializingCollection = false; this.setIsLoadingStocks(false); });
      const apiCallConfig = {loadingOverlay: false, displayErrors: false};

      this._getAPICall(url, successHandler, failureHandler, apiCallConfig);

    },

    /* ---------------------------------------------
     * Creates a new favorites workspace containing
     * the tickers currently loaded in this search.
     * -------------------------------------------*/
    _showCreateFavoritesModal() {
      if (!this._g_IsUserLogged) return;

      // Initialize modal with default values
      this.folderName = this.search_text || 'Nueva carpeta';
      this.selectedColor = this.gridColors[Math.floor(Math.random() * this.gridColors.length)];
      this.showCreateFavoritesModal = true;
      
      this.$nextTick(() => {
        if (this.$refs.createFavInput) {
          this.$refs.createFavInput.focus();
          this.$refs.createFavInput.select();
        }
      });
    },

    _toggleColorGrid(event) {
      if (this.showColorGrid) {
        this.showColorGrid = false;
        return;
      }

      const triggerButton = event.target.closest('button');
      if (!triggerButton) return;

      const buttonRect = triggerButton.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      const gridWidth = 130;
      const gridHeight = 130;
      
      let posLeft = buttonRect.right + 8;
      let posTop = buttonRect.top;
      
      if (posLeft + gridWidth > viewportWidth) {
        posLeft = buttonRect.left - gridWidth - 8;
      }
      
      if (posLeft < 0) {
        posLeft = buttonRect.left;
        posTop = buttonRect.bottom + 8;
        
        if (posTop + gridHeight > viewportHeight) {
          posTop = buttonRect.top - gridHeight - 8;
        }
      }
      
      posLeft = Math.max(8, Math.min(posLeft, viewportWidth - gridWidth - 8));
      posTop = Math.max(8, Math.min(posTop, viewportHeight - gridHeight - 8));
      
      this.colorGridStyle = {
        position: 'fixed',
        top: `${posTop}px`,
        left: `${posLeft}px`,
      };

      this.showColorGrid = true;
    },

    _selectColor(color) {
      this.selectedColor = color;
      this.showColorGrid = false;
    },

    _createFavoritesFolder() {
      if (!this.folderName.trim()) return;

      // Collect unique tickers from the currently loaded stocks array
      const tickers = (this.stocks || [])
        .map(s => s.ticker || s.id || s.symbol)
        .filter(Boolean)
        .map(t => t.toUpperCase());

      if (tickers.length === 0) {
        this.$vueOnToast?.pop('info', 'Sin valores', 'No hay tickers para guardar.');
        return;
      }

      const params = new URLSearchParams();
      params.append('name', this.folderName.trim());
      params.append('color', this.selectedColor);
      params.append('tickers', JSON.stringify(Array.from(new Set(tickers))));

      const url = '/api/v1/stock-finder/favorite-folder/create';

      const successCallback = () => {
        this.$vueOnToast?.pop('success', 'Favoritos', `Espacio "${this.folderName}" creado con éxito.`);
        this.setWorkspaceCreated(true);
      };

      const failureCallback = () => {
        /* no-op: toast handled by failure handler */
      };

      const successHandler = new APICaller.SuccessHandler(successCallback);
      const failureHandler = new APICaller.FailureHandler('999', 'Error creando favoritos.', failureCallback);

      this._postAPICall(url, params, successHandler, failureHandler);
      
      // Close modal and reset
      this.folderName = '';
      this.showCreateFavoritesModal = false;
      this.showColorGrid = false;
    },

    _handleClickOutside(event) {
      if (this.showColorGrid && this.$refs.colorGridPopup && !this.$refs.colorGridPopup.contains(event.target)) {
        const isTrigger = event.target.closest('.color-trigger-btn');
        if (!isTrigger) {
          this.showColorGrid = false;
        }
      }
    },

    _handleResize() {
      if (this.showColorGrid) {
        this.showColorGrid = false;
      }
    },

    formatInformeSlugForDisplay(slug) {
      // Convert slug from dd-mm-yyyy format back to dd/mm/yyyy for display
      if (!slug) return '';
      
      // Decode the slug first in case it's URL encoded
      const decodedSlug = decodeURIComponent(slug);
      
      // Convert dd-mm-yyyy to dd/mm/yyyy
      return decodedSlug.replace(/-/g, '/');
    },
  },
}
</script>


<style lang="scss">
.stockchart-chart {
    height: calc(89vh);
    position:relative;
    overflow:hidden;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
    background-color: var(--color-custom-stockchart-background);
}

@media screen and (max-height: 800px) {
  .stockchart-chart{
    margin-right: 21px;
  }
}

.stockchart{
    height: 100%;
    overflow:hidden;
}
#iframe, #mobile-iframe {
    position: relative;
    z-index: 2;
    transition: opacity 0.5s ease-in-out;
}

/* Iframe loading/loaded states for fade effect */
.iframe-loading {
  opacity: 0;
}

.iframe-loaded {
  opacity: 1;
}

.title-searches{
    background-color: var(--color-custom-search-bar);
    text-align: center;
    height: 40px;
    margin-left: 82px !important;
    margin-right: 82px !important;
  }

  .close-searches{
    font-size: 16px;
    right: 30px;
    position: relative;
    margin-top: 10px;
    color: white;
    float: right;
  }

  .search-text{
    margin-top: 30px !important;
    line-height: 40px !important;
    color: white;
  }

  .chart-with-search-tittle{
    height: 94% !important;
  }

  #fullscreen-button-container-all-pages{
    display: none;
  }
  .banner-big-bank{
    position: absolute;
    width: 20%;
    float: right;
    z-index: 3;
    right: 7%;
  }

  .iframe-loading-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-custom-stockchart-background);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  .wave {
    width: 5px;
    height: 100px;
    background: linear-gradient(45deg, var(--primary-light, #4E6E82), var(--primary, #245275));
    margin: 10px;
    animation: wave 1s ease-in-out infinite;
    border-radius: 20px;
  }

  .wave:nth-child(2) {
    animation-delay: 0.1s;
  }

  .wave:nth-child(3) {
    animation-delay: 0.2s;
  }

  @keyframes wave {
    0% {
      transform: scale(0.3);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.3);
    }
  }

  .full-screen-loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background-color: var(--color-background, #fff);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .vanilla-input-container {
    margin: 6px 0 10px 6px;
    width: 15%;
  }
  
  .vanilla-ticker-input {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    border: 1px solid var(--color-border, #ccc);
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
    background-color: var(--color-input-background, #fff);
    color: var(--color-text, #333);
  }
  
  .vanilla-ticker-input:focus {
    border-color: var(--primary, #245275);
    box-shadow: 0 0 0 2px rgba(36, 82, 117, 0.2);
  }

  .save-fav-btn{
    background: none;
    border: none;
    cursor: pointer;
    color: white;
    margin: 0 12px;
    padding: 6px 12px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    vertical-align: middle;
  }
  
  .save-fav-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
  }
  
  .save-fav-btn .material-icons-outlined{
    font-size: 20px;
  }
  
  .save-fav-text {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }

  /* Modal Overlay */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  /* Modal Content - matching Favoritos.vue styles */
  .favorites-modal-content {
    background-color: var(--color-background, white);
    border-radius: 8px;
    width: 420px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: var(--color-text-primary, #0F0F1A);
    box-shadow: 0 4px 20px rgba(15, 15, 26, 0.15);
  }

  /* Modal Header */
  .modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid var(--color-outline, rgba(0, 0, 0, 0.12));
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header-icon {
    color: var(--primary, #00AEDD);
    font-size: 22px;
  }

  .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }

  .modal-close-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--color-text-secondary, #606577);
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    transition: background-color 0.2s ease-in-out;
  }

  .modal-close-btn:hover {
    background-color: var(--color-surface, #F3F4F7);
  }

  /* Modal Body */
  .modal-body {
    padding: 20px;
    overflow-y: auto;
    flex-grow: 1;
  }

  .modal-description {
    margin-bottom: 20px;
    font-size: 14px;
    color: var(--color-text-secondary, #606577);
    line-height: 1.5;
  }

  /* Create Input Wrapper */
  .create-input-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
  }

  /* Icon button base style */
  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-secondary, #606577);
    transition: color 0.2s ease, background-color 0.2s ease;
  }

  .icon-button:hover {
    background-color: var(--color-muted, #EAECEF);
  }

  .color-trigger-btn .material-icons-outlined {
    font-size: 22px;
    display: block;
  }

  /* Vanilla Input Styles */
  .vanilla-input {
    flex-grow: 1;
    height: 36px;
    padding: 6px 12px;
    font-size: 14px;
    border: 1px solid var(--color-outline, rgba(0, 0, 0, 0.12));
    border-radius: 4px;
    background-color: var(--color-background, white);
    color: var(--color-text-primary, #0F0F1A);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-sizing: border-box;
  }

  .vanilla-input:focus {
    outline: none;
    border-color: var(--primary, #00AEDD);
    box-shadow: 0 0 0 2px rgba(0, 174, 221, 0.2);
  }

  /* Modal Footer */
  .modal-footer {
    padding: 16px 20px;
    border-top: 1px solid var(--color-outline, rgba(0, 0, 0, 0.12));
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-shrink: 0;
  }

  /* Action Buttons */
  .action-btn {
    border: none;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    padding: 0 16px;
    height: 36px;
    transition: all 0.2s ease;
    font-weight: 600;
  }

  .secondary-btn {
    background-color: var(--color-surface, #F3F4F7);
    color: var(--color-text-primary, #0F0F1A);
    border: 1px solid var(--color-outline, rgba(0, 0, 0, 0.12));
  }

  .secondary-btn:hover:not(:disabled) {
    background-color: var(--color-background, #EAECEF);
  }

  .primary-btn {
    background-color: var(--primary, #00AEDD);
    color: white;
  }

  .primary-btn:hover:not(:disabled) {
    background-color: #0096c7;
  }

  .primary-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Custom Color Grid Popup Styles */
  .color-grid-popup {
    background-color: var(--color-background, white);
    border-radius: 8px;
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.25);
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(4, 24px);
    grid-template-rows: repeat(4, 24px);
    gap: 8px;
    z-index: 99999;
    border: 1px solid var(--color-outline, rgba(0, 0, 0, 0.1));
  }

  .color-grid-item {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid var(--color-outline, rgba(0, 0, 0, 0.1));
    transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .color-grid-item:hover {
    transform: scale(1.15);
    border-color: var(--color-text-primary, #0F0F1A);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .color-grid-item:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--primary, #00AEDD);
    transform: scale(1.15);
  }

  /* Root wrapper - ensure it doesn't interfere with layout */
  .stockchart-root {
    height: 100%;
    width: 100%;
  }
</style>
